module.exports = {
  apiHost: "https://api.elan.sensoreal.com.au",
  assetsHost: "https://assets.elan.sensoreal.com.au",
  contact: {
    address: "107-109 Kremzow Road, Warner, QLD 4500",
    email: "elan@avid.com.au",
    phone: "1800 524 730",
    website: "https://elan.avid.com.au",
  },
  formTemplate: "default",
  header: {
    logo: "",
    text: {
      en: "Your Elan Selections",
      ar: "",
    },
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  footerLogo: "https://assets.elan.sensoreal.com.au/misc/AVID_White_72dpi.png",
  links: {
    instagram: "https://www.instagram.com/avid_together/",
    facebook: "https://www.facebook.com/elan.warner/",
    linkedin: "https://au.linkedin.com/company/avid-property-group",
    privacy: "https://avid.com.au/privacy-policy",
    twitter: "",
    youtube: "https://www.youtube.com/channel/UCEnh4QABTOnsovDd-Hg45OQ",
  },
  style: {
    primaryColor: "#0d4a4b",
    textColor: "#fff",
  },
};
